import { onMounted, onUnmounted } from 'vue';
import type { Ref } from 'vue';

export const useExploreSearch = (filters: Ref<any>, queryRef: Ref<string>, applyFilters: () => void) => {
  // Handler defined at composable scope so onUnmounted can reference it
  const handleExploreSearch = (event: CustomEvent) => {
    if (filters.value.query !== event.detail.query) {
      filters.value.query = event.detail.query;
      queryRef.value = event.detail.query;
      applyFilters();
    }
  };

  onMounted(() => {
    window.addEventListener('explore-search', handleExploreSearch as EventListener);
  });

  onUnmounted(() => {
    window.removeEventListener('explore-search', handleExploreSearch as EventListener);
  });
};
